import script from "./Stava.vue?vue&type=script&setup=true&lang=js"
export * from "./Stava.vue?vue&type=script&setup=true&lang=js"

import "./Stava.vue?vue&type=style&index=0&id=2cfe5e9c&lang=css"

const __exports__ = script;

export default __exports__